import {Injectable} from '@angular/core';

import {NavItem} from '../models/NavItem';
import {Navigation} from "../models/Navigation";
import {of} from "rxjs/internal/observable/of";
import {Observable} from "rxjs/internal/Observable";

@Injectable()
export class NavigationService {

  staticNavigation = [
    new Navigation("Resources", [
      new NavItem("File Transmission", "content/File_Transmission")
      , new NavItem("FAQ", "content/FAQ")
    ])];

  staticFooterList = [
    new NavItem("About", "content/About")
    , new NavItem("Accessibility Statement", "content/Accessibility_Statement")
    , new NavItem("Privacy Policy", "content/Privacy_Policy")
    , new NavItem("Notices & Agreements", "content/Notices_Agreements")
    , new NavItem("Contact Us", "content/Contact_Us")
  ];

  constructor() {
  }

  getLeftNav(): Observable<Navigation[]> {
    return of(this.staticNavigation);
  }

  getFooterNav(): Observable<NavItem[]> {
    return of(this.staticFooterList);
  }
}
